import { create } from 'zustand';

export type PricingManagementAlertInput = {
  snackMessage: string | undefined,
  setSnackMessage: (message: string | undefined) => void,
}

const usePricingManagamentAlertsStore = create<PricingManagementAlertInput>((set) => ({
  snackMessage: undefined,
  setSnackMessage: (snackMessage: string | undefined) => set({ snackMessage }),
}));

export default usePricingManagamentAlertsStore;
